module.exports = __webpack_public_path__ + "static/img/IIIFestival_Ajedrez-1024x576.3d14627.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/festival2021/IIIFestival_Ajedrez-1024x576.jpg
// module id = 289
// module chunks = 10